import CategoryCard from '@/app-theme/views/home/CategoryCard.vue'
import {toSlug} from '@/app-core/lib/utils/string'

export default {
  name      : 'CategorySlider',
  components: {CategoryCard},
  directives: {},
  mixins    : [],
  props     : {
    title: {
      type   : String,
      default: ''
    },

    categories: {
      type   : Array,
      default: () => []
    }
  },
  enums: {},
  data() {
    return {
      hasPrev: false,
      hasNext: false
    }
  },
  computed: {
    cardWidth() {
      if (this.$vuetify.breakpoint.xs) return 120
      if (this.$vuetify.breakpoint.sm) return 120
      if (this.$vuetify.breakpoint.md) return 150
      if (this.$vuetify.breakpoint.lg) return 180

      return 230
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    this.$watch(() => this.$refs.categoriesSlideGroup.hasPrev, (newValue) => {
      this.hasPrev = newValue
    })
    this.$watch(() => this.$refs.categoriesSlideGroup.hasNext, (newValue) => {
      this.hasNext = newValue
    })
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toSlug,

    /**
     * onAffixClick
     *
     * @param location {String}
     */
    onAffixClick(location) {
      this.$refs.categoriesSlideGroup.onAffixClick(location)
    }
  }
}
